<template>
    <div class="text-field"
         :class="{
            'text-field--floating-label': shouldFloatLabel,
            'text-field--has-focus': hasFocus
         }"
    >
        <div class="text-field__label-wrapper" v-if="label">
            <label class="text-field__label"
                   :for="id"
            >
                {{ label }}
            </label>
        </div>

        <input class="text-field__input"
               v-if="!isTextArea"
               :id="id"
               :type="type"
               :value="value"
               @change="onChange($event)"
               @input="onInput($event)"
               @focus="onFocus"
               @blur="onBlur"
        />

        <textarea class="text-field__textarea"
                  :class="{
                    'text-field__textarea--no-resize': !resizable
                  }"
                  v-if="isTextArea"
                  :id="id"
                  :value="value"
                  :cols="cols"
                  :rows="rows"
                  @change="onChange($event)"
                  @input="onInput($event)"
                  @focus="onFocus"
                  @blur="onBlur"
        ></textarea>

        <div class="text-field__line-wrapper">
            <div class="text-field__line"></div>
        </div>
    </div>
</template>

<script>
import { uid } from '../../utils/uid';

export default {
    model: {
        prop: 'value',
        event: 'input',
        lazyEvent: 'change'
    },
    props: {
        id: {
            type: String,
            default: () => uid('text-field_')
        },
        value: {
            default: () => ''
        },
        label: {
            type: String,
            default: () => ''
        },
        type: {
            type: String,
            default: () => 'text'
        },
        cols: {
            type: Number,
            default: () => -1
        },
        rows: {
            type: Number,
            default: () => -1
        },
        resizable: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            hasFocus: false
        }
    },
    computed: {
        isTextArea() {
            return this.type === 'textarea';
        },
        hasValue() {
            if (typeof this.value === 'number') {
                return true;
            }

            return this.value && this.value.length > 0;
        },
        shouldFloatLabel() {
            return this.hasValue || this.hasFocus;
        }
    },
    methods: {
        onInput(event) {
            this.$emit('input', event.target.value);
        },
        onChange(event) {
            this.$emit('change', event.target.value);
        },
        onFocus() {
            this.hasFocus = true;
        },
        onBlur() {
            this.hasFocus = false;
        }
    }
}
</script>

<style scoped lang="scss">

.text-field {
    position: relative;
    width: 100%;
    background-color: $color-input-background;
}

.text-field__label-wrapper {
    position: absolute;
    height: 100%;
    width: 100%;
    pointer-events: none;
    padding: 0.75rem 0.5rem 0;
}

.text-field__label {
    display: inline-block;
    transition: transform ease .2s, color ease .2s;
    transform-origin: 0 0;
    font-size: 1rem;

    .text-field--floating-label & {
        transform: scale(0.75) translateY(-0.625rem);
    }

    .text-field--has-focus & {
        color: $color-action;
    }
}

.text-field__input {
    width: 100%;
    font-size: 1rem;
    padding: 1.25rem 0.5rem 0.5rem;
    border: 0;
    background: transparent;
    outline: 0;
}

.text-field__textarea {
    width: 100%;
    font-size: 1rem;
    margin-top: 1.5rem;
    padding: 0 0.5rem 0.5rem;
    border: 0;
    background: transparent;
    outline: 0;
    resize: vertical;

    &--no-resize {
        resize: none;
    }
}

.text-field__line-wrapper {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    height: 0.125rem;
}

.text-field__line {
    width: 100%;
    height: 100%;
    background-color: $color-action;
    transition: transform ease-out .15s;
    transform: scaleX(0);

    .text-field--has-focus & {
        transform: scaleX(1);
    }
}
</style>
